var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.tencent_user_ready)?_c('div',{on:{"click":_vm.openTencent}},[_c('img',{style:({height: _vm.height+'px', cursor: 'pointer'}),attrs:{"src":require("@/assets/images/opentencent.png"),"alt":"open-tencent"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }